const achievementlist = [
  {
    id: 1,
    title: "COSIDICI Award Winner",
    desc: "Our company has been honored with the prestigious Best Entrepreneur COSIDICI Award, recognizing outstanding entrepreneurial excellence, innovation, and significant contributions to the industry. This accolade underscores our dedication to excellence and our relentless pursuit of innovative solutions in our field.",
    img: "trophywithBG.png",
    year: "2023",
  },
  {
    id: 2,
    title: "CIPET Certification",
    desc: "We are thrilled to announce that V Pack Company has been awarded certification by the Central Institute of Petrochemicals Engineering & Technology (CIPET). This prestigious certification confirms the exceptional quality and safety of our plastic caps. Our products have successfully passed rigorous testing for overall migration, ensuring they meet the highest industry standards. This achievement highlights our commitment to excellence and our dedication to providing top-quality products to our customers.",
    img: "cipet-certificate.jpg",
    year: "2023",
  },
];
export default achievementlist;
